/**
 * Контекст сторов — вынесен из src/index.js (Фаза 2 Vite, 13.08.2026).
 * Причина: stores.ts импортировал StoreContext из entry ('.'), и под
 * Vite-HMR refresh-проход ре-исполнял index.js — создавался НОВЫЙ
 * StoreContext, потребители со старым Provider бросали
 * «StoreProvider missing» (белый экран после любого изменения файла).
 * Отдельный компонентный модуль — стабильная refresh-граница; для
 * webpack-цепочки изменение прозрачно.
 */
import { createContext, useRef } from 'react';
import type { FC, ReactNode } from 'react';
import appStore from './store/AppStore';
import cartStore from './store/CartStore';
import catalogStore from './store/CatalogStore';
import configStore from './store/ConfigStore';
import modalsStore from './store/ModalsStore';
import userStore from './store/UserStore';
import utilsStore from './store/UtilsStore';
import xStore from './store/XStore';
import seoStore from './store/SeoStore';
import barMenuStore from '@store/BarMenuStore';

export const store = {
  appStore,
  configStore,
  xStore,
  userStore,
  cartStore,
  modalsStore,
  catalogStore,
  utilsStore,
  barMenuStore,
  seoStore
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const StoreContext = createContext<any>(null);

export const StoreProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const storeRef = useRef<typeof store | null>(null);

  if (!storeRef.current) {
    storeRef.current = store;
  }

  return (
    <StoreContext.Provider value={storeRef.current}>
      {children}
    </StoreContext.Provider>
  );
};
